var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { background: "#fff" } }, [
    _c(
      "div",
      { staticClass: "section", staticStyle: { "min-width": "1200px" } },
      [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestinationCustomsData")))
        ]),
        _c("div", [
          _c(
            "div",
            { staticClass: "customs-data-container" },
            [
              _vm._l(_vm.customsDataList, function(item, index) {
                return _c(
                  "div",
                  { key: item.uuid || index, staticClass: "customs-data-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "row-header" },
                      [
                        _c("span", { staticClass: "row-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.ProductName")) +
                              _vm._s(index + 1)
                          )
                        ]),
                        !_vm.readonly
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteItem(index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.DeleteThisProduct"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("el-divider"),
                    _c(
                      "div",
                      { staticClass: "customs-section" },
                      [
                        _c("span", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.ConsignInfo")))
                        ]),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              disabled: _vm.readonly || _vm.consignReadonly,
                              "label-width": "100px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly || _vm.consignReadonly,
                                    type: "textarea",
                                    rows: 2
                                  },
                                  model: {
                                    value: item.hsCode,
                                    callback: function($$v) {
                                      _vm.$set(item, "hsCode", $$v)
                                    },
                                    expression: "item.hsCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ChineseName")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly || _vm.consignReadonly,
                                    type: "textarea",
                                    rows: 2
                                  },
                                  model: {
                                    value: item.chineseName,
                                    callback: function($$v) {
                                      _vm.$set(item, "chineseName", $$v)
                                    },
                                    expression: "item.chineseName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.EnglishName")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly || _vm.consignReadonly,
                                    type: "textarea",
                                    rows: 2
                                  },
                                  model: {
                                    value: item.englishName,
                                    callback: function($$v) {
                                      _vm.$set(item, "englishName", $$v)
                                    },
                                    expression: "item.englishName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c("template", { slot: "label" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#F56C6C" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("SeaExport.DeclaredValue")
                                      ) +
                                      " "
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { "max-width": "300px" },
                                      attrs: {
                                        disabled:
                                          _vm.readonly || _vm.consignReadonly,
                                        min: 0,
                                        precision: 2,
                                        "controls-position": "right"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.calculateEstimatedTariff(
                                            index
                                          )
                                        }
                                      },
                                      model: {
                                        value: item.declaredValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "declaredValue", $$v)
                                        },
                                        expression: "item.declaredValue"
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "90px",
                                          "margin-left": "5px"
                                        },
                                        attrs: {
                                          disabled:
                                            _vm.readonly || _vm.consignReadonly,
                                          filterable: "",
                                          placeholder: "币种"
                                        },
                                        model: {
                                          value: item.currency,
                                          callback: function($$v) {
                                            _vm.$set(item, "currency", $$v)
                                          },
                                          expression: "item.currency"
                                        }
                                      },
                                      _vm._l(_vm.currencyList, function(
                                        currency
                                      ) {
                                        return _c("el-option", {
                                          key: currency.uuid,
                                          attrs: {
                                            label: currency.code,
                                            value: currency.code
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("SeaExport.TariffRate") }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: {
                                    flex: "1",
                                    "max-width": "300px"
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.readonly || _vm.consignReadonly,
                                    min: 0,
                                    precision: 2,
                                    "controls-position": "right"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.calculateEstimatedTariff(index)
                                    }
                                  },
                                  model: {
                                    value: item.tariffRate,
                                    callback: function($$v) {
                                      _vm.$set(item, "tariffRate", $$v)
                                    },
                                    expression: "item.tariffRate"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "5px" } },
                                  [_vm._v("%")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.EstimatedTariff")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "60px" },
                                      attrs: {
                                        value: item.estimatedTariff || 0,
                                        disabled: ""
                                      }
                                    }),
                                    _c(
                                      "span",
                                      { staticStyle: { "margin-left": "5px" } },
                                      [_vm._v(_vm._s(item.currency || "USD"))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "estimated-tariff-tip",
                                        staticStyle: {
                                          "margin-left": "10px",
                                          background: "#FDF6EC",
                                          padding: "2px 8px",
                                          "border-radius": "3px",
                                          "font-size": "12px",
                                          color: "#E6A23C"
                                        }
                                      },
                                      [_vm._v("仅预估参考，实际以海关账单为准")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-divider"),
                    _c(
                      "div",
                      { staticClass: "customs-section" },
                      [
                        _c(
                          "div",
                          { staticClass: "section-title-row" },
                          [
                            _c("span", { staticClass: "section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DestPortCustomsClearanceInfo"
                                  )
                                )
                              )
                            ]),
                            _vm.showCopyConsignBtn &&
                            !_vm.customsSectionReadonly
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "copy-consign-btn",
                                    attrs: { icon: "el-icon-document-copy" },
                                    on: {
                                      click: function($event) {
                                        return _vm.copyConsignToCustoms(index)
                                      }
                                    }
                                  },
                                  [_vm._v("复制委托信息")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form",
                          {
                            attrs: {
                              disabled:
                                _vm.readonly || _vm.customsSectionReadonly,
                              "label-width": "100px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      _vm.customsSectionReadonly,
                                    placeholder: "请输入清关HS编码"
                                  },
                                  model: {
                                    value: item.customsHsCode,
                                    callback: function($$v) {
                                      _vm.$set(item, "customsHsCode", $$v)
                                    },
                                    expression: "item.customsHsCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ChineseName")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      _vm.customsSectionReadonly,
                                    placeholder: "请输入清关中文品名"
                                  },
                                  model: {
                                    value: item.customsChineseName,
                                    callback: function($$v) {
                                      _vm.$set(item, "customsChineseName", $$v)
                                    },
                                    expression: "item.customsChineseName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.EnglishName")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "300px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      _vm.customsSectionReadonly,
                                    placeholder: "请输入清关英文品名"
                                  },
                                  model: {
                                    value: item.customsEnglishName,
                                    callback: function($$v) {
                                      _vm.$set(item, "customsEnglishName", $$v)
                                    },
                                    expression: "item.customsEnglishName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomsValue")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { "max-width": "300px" },
                                      attrs: {
                                        disabled:
                                          _vm.readonly ||
                                          _vm.customsSectionReadonly,
                                        min: 0,
                                        precision: 2,
                                        "controls-position": "right"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.calculateCustomsTariff(
                                            index
                                          )
                                        }
                                      },
                                      model: {
                                        value: item.customsValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "customsValue", $$v)
                                        },
                                        expression: "item.customsValue"
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "90px",
                                          "margin-left": "5px"
                                        },
                                        attrs: {
                                          disabled:
                                            _vm.readonly ||
                                            _vm.customsSectionReadonly,
                                          filterable: "",
                                          placeholder: "币种"
                                        },
                                        model: {
                                          value: item.customsValueCurrency,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "customsValueCurrency",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.customsValueCurrency"
                                        }
                                      },
                                      _vm._l(_vm.currencyList, function(
                                        currency
                                      ) {
                                        return _c("el-option", {
                                          key: currency.uuid,
                                          attrs: {
                                            label: currency.code,
                                            value: currency.code
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomsTariff")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { "max-width": "300px" },
                                      attrs: {
                                        disabled: "",
                                        min: 0,
                                        precision: 2,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: item.customsTariff,
                                        callback: function($$v) {
                                          _vm.$set(item, "customsTariff", $$v)
                                        },
                                        expression: "item.customsTariff"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      { staticStyle: { "margin-left": "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.customsValueCurrency || "USD"
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("SeaExport.TariffRate") }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: {
                                    flex: "1",
                                    "max-width": "300px"
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      _vm.customsSectionReadonly,
                                    min: 0,
                                    precision: 2,
                                    "controls-position": "right"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.calculateCustomsTariff(index)
                                    }
                                  },
                                  model: {
                                    value: item.customsTariffRate,
                                    callback: function($$v) {
                                      _vm.$set(item, "customsTariffRate", $$v)
                                    },
                                    expression: "item.customsTariffRate"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "5px" } },
                                  [_vm._v("%")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomsBroker")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "max-width": "300px",
                                      width: "300px"
                                    },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        _vm.customsSectionReadonly,
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      placeholder: "请选择清关行",
                                      "remote-method": _vm.searchCustomsBroker
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onCustomsBrokerChange(item)
                                      }
                                    },
                                    model: {
                                      value: item.customsBrokerCmpIdx,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "customsBrokerCmpIdx",
                                          $$v
                                        )
                                      },
                                      expression: "item.customsBrokerCmpIdx"
                                    }
                                  },
                                  _vm._l(_vm.brokerOptions, function(broker) {
                                    return _c("el-option", {
                                      key: broker.cmpIdx,
                                      attrs: {
                                        label:
                                          broker.chineseName ||
                                          broker.englishName,
                                        value: String(broker.cmpIdx)
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("SeaExport.Bond") } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "max-width": "300px",
                                      width: "300px"
                                    },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        _vm.customsSectionReadonly,
                                      filterable: "",
                                      placeholder: "请选择Bond编号"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onBondChange(item)
                                      }
                                    },
                                    model: {
                                      value: item.bond,
                                      callback: function($$v) {
                                        _vm.$set(item, "bond", $$v)
                                      },
                                      expression: "item.bond"
                                    }
                                  },
                                  _vm._l(_vm.bondList, function(bond) {
                                    return _c("el-option", {
                                      key: bond.uuid,
                                      attrs: {
                                        label: bond.bondNo,
                                        value: bond.bondNo
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              !_vm.readonly
                ? _c(
                    "div",
                    { staticClass: "add-row-area" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.addRow }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.AddMultipleProductArea"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }